import { CardContent } from '@bitrise/bitkit';
import React, { useEffect, FunctionComponent } from 'react';
import { trackEvent } from '../../../../utils/tracking';
import { TypeOnboardingSetupOption } from '../../Onboarding';

type Props = { name: TypeOnboardingSetupOption };

const Guide: FunctionComponent<Props> = ({ name, ...rest }) => {
  useEffect(() => {
    trackEvent('Onboarding.Setup.Visit', {
      guide: name,
    });
  }, [name]);

  return <CardContent margin="x10" {...rest} />;
};

export default Guide;
